import { render, staticRenderFns } from "./luiyan.vue?vue&type=template&id=ad89dbc8&scoped=true"
import script from "./luiyan.vue?vue&type=script&setup=true&lang=js"
export * from "./luiyan.vue?vue&type=script&setup=true&lang=js"
import style0 from "./luiyan.vue?vue&type=style&index=0&id=ad89dbc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad89dbc8",
  null
  
)

export default component.exports